import { isEqual } from 'underscore';
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LegacyBidStrategy } from './legacy-bid-strategy';

const LegacyBidStrategyWithCustomValidation = ({
  validationProps, updateValidation, ...restProps
}) => {
  const { data } = validationProps;
  const i18n = useContext(I18nContext);
  const popupIds = {
    BidStrategy: 'pop_BA_PMAX_BidStrategy',
  };

  const activity = useContext(ActivityContext);

  const onChange = useCallback((newData, newIsValid, isFromInitialization) => {
    const newBiddingScheme = { BiddingScheme: newData };
    updateValidation(
      newIsValid ? [] : [i18n.getString(_TL_('Bid Strategy has validation errors'))],
      isEqual(newBiddingScheme, data) ? data : newBiddingScheme,
      !isFromInitialization
    );

    if (activity) {
      activity.signal(`onLegacyBidStrategyChange - ${JSON.stringify(newBiddingScheme)} - isValid: ${newIsValid}}`);
    }
  }, [i18n, updateValidation, data, activity]);

  return (
    <LegacyBidStrategy
      entityType="Campaign"
      onChange={onChange}
      BiddingScheme={data.BiddingScheme}
      CampaignSettings={data.CampaignSettings}
      popupIds={popupIds}
      {...restProps}
    />
  );
};

LegacyBidStrategyWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      BiddingScheme: PropTypes.shape({
        Type: PropTypes.string,
      }),
      CampaignSettings: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedLegacyBidStrategy = withCustomValidation(LegacyBidStrategyWithCustomValidation);

